import * as Yup from "yup";
import checkout from "./Form";

const {
  formField: {
    pa_id,
    status,
    full_name,
    social_name,
    cpf,
    birth_date,
    gender,
    document_type,
    document_number,
    issuing_body,
    document_uf,
    issue_date,
    nationality,
    birth_city,
    birth_uf,
    mothers_name,
    fathers_name,
    email,
    phone,
    contact_type,
    contact,
    cep,
    street,
    number,
    complement,
    state,
    neighborhood,
    city,
    mailing_address,
    income,
    private_description,
    reason_reprovation,
    account_number,
    situation_document,
    hiring_type,
    responsible_email,
  },
} = checkout;

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  // messages
  Yup.object().shape({}),
  // documents
  Yup.object().shape({}),
  // datas
  Yup.object().shape({
    [full_name.name]: Yup.string()
      .matches(
        /^[a-zA-Z\u00C0-\u00FF\s]*$/,
        "O campo Nome Completo só aceita letras"
      ),
      // .required(fullName.errorMsg),
    [social_name.name]: Yup.string()
      .matches(
        /^[a-zA-Z\u00C0-\u00FF\s]*$/,
        "O campo Nome Social só aceita letras"
      ),
      // .required(socialName.errorMsg),
    [cpf.name]: Yup.string()
      .test("cpf", "CPF inválido", function (item) {
        var strCPF = item ? item.replaceAll(".", "").replaceAll("-", "") : "";
        var Soma;
        var Resto;
        Soma = 0;
        if (strCPF === "00000000000") return false;

        for (let i = 1; i <= 9; i++)
          Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;

        if (Resto === 10 || Resto === 11) Resto = 0;
        if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

        Soma = 0;
        for (let i = 1; i <= 10; i++)
          Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;

        if (Resto === 10 || Resto === 11) Resto = 0;
        if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
        return true;
      })
      // .required(CPF.errorMsg)
      .min(14, cpf.invalidMsg),
    [birth_date.name]: Yup.string()
      // .required(birth_date.errorMsg)
      .min(10, birth_date.invalidMsg),
    // [value]: Yup.string().required(sex.errorMsg),
    // [documentType.name]: Yup.string().required(documentType.errorMsg),
    [document_number.name]: Yup.string()
      .matches(/^\d+$/, "O campo Número do Documento só aceita números"),
      // .required(documentNumber.errorMsg),
    [issuing_body.name]: Yup.string()
      .matches(
        /^[a-zA-Z\u00C0-\u00FF\s]*$/,
        "O campo Orgão Emissor só aceita letras"
      ),
      // .required(issuingAgency.errorMsg),
    [document_uf.name]: Yup.string()
      .max(2, "O campo UF necessita conter apenas dois carácteres")
      .matches(/^[a-zA-Z]+$/, "O campo UF só aceita letras"),
      // .required(FUData.errorMsg),
    [issue_date.name]: Yup.string(),
    // .required(issueDate.errorMsg),
    [nationality.name]: Yup.string()
      .matches(
        /^[a-zA-Z\u00C0-\u00FF\s]*$/,
        "O campo Nacionalidade só aceita letras"
      ),
      // .required(nationality.errorMsg),
    [birth_city.name]: Yup.string()
      .matches(
        /^[a-zA-Z\u00C0-\u00FF\s]*$/,
        "O campo Cidade de Nascimento só aceita letras"
      ),
      // .required(birthCity.errorMsg),
    [birth_uf.name]: Yup.string()
      .max(
        2,
        "O campo UF de nascimento necessita conter apenas dois carácteres"
      )
      .matches(/^[a-zA-Z]+$/, "O campo UF de nascimento só aceita letras"),
      // .required(birthFU.errorMsg),
    [mothers_name.name]: Yup.string()
      .matches(
        /^[a-zA-Z\u00C0-\u00FF\s]*$/,
        "O campo Nome da Mãe só aceita letras"
      ),
      // .required(motherName.errorMsg),
    [fathers_name.name]: Yup.string().matches(
      /^[a-zA-Z\u00C0-\u00FF\s]*$/,
      "O campo Nome do Pai só aceita letras"
    ),
  }),
  // contacts
  Yup.object().shape({
    [email.name]: Yup.string()
    // .required(email.errorMsg)
    .email(email.invalidMsg),
    [phone.name]: Yup.string()
      // .required(phone.errorMsg)
      .min(14, phone.invalidMsg),
    // [formOfContact.name]: Yup.string().required(formOfContact.errorMsg),
    [contact.name]: Yup.string(),
      // .required(contact.errorMsg),
  }),
  // address
  Yup.object().shape({
    [cep.name]: Yup.string()
    // .required(cep.errorMsg)
    .min(9, cep.invalidMsg),
    [street.name]: Yup.string(),
    // .required(street.errorMsg),
    [number.name]: Yup.string()
      .matches(/^\d+$/, "O campo Número só aceita números"),
      // .required(number.errorMsg),
    // [complements.name]: Yup.string().required(complements.errorMsg),
    [state.name]: Yup.string()
      .max(2, "O campo UF necessita conter apenas dois carácteres")
      .matches(/^[a-zA-Z]+$/, "O campo UF só aceita letras"),
      // .required(FUAddress.errorMsg),
    [neighborhood.name]: Yup.string(),
    // .required(neighborhood.errorMsg),
    [city.name]: Yup.string()
      .matches(/^[a-zA-Z\u00C0-\u00FF\s]*$/, "O campo Cidade só aceita letras"),
      // .required(city.errorMsg),
    [mailing_address.name]: Yup.string()
    // .required(mailingAddress.errorMsg),
  }),
  // complements
  Yup.object().shape({
    [contact_type.name]: Yup.string().required(contact_type.errorMsg),
    [gender.name]: Yup.number().required(gender.errorMsg),
    [document_type.name]: Yup.number().required(document_type.errorMsg),
    [income.name]: Yup.string(),
    [complement.name]: Yup.string(),
    [pa_id.name]: Yup.number().required(),
    [status.name]: Yup.number(),
    [private_description.name]: Yup.string(),
    [reason_reprovation.name]: Yup.string(),
    [account_number.name]: Yup.string(),
    [situation_document.name]: Yup.string(),
    [hiring_type.name]: Yup.string(),
    [responsible_email.name]: Yup.string(),
  }),
  // descriptions
  Yup.object().shape({}),
];
